
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../Home/AppHome.css";
import '../Admin/Admin.css';
import Headers from "./Headers";

export default function NewMemberHome() {
  const navigate = useNavigate();

       useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  return (
    <div className="dashboard">

      <Headers />

      <div className="welcome-container">
        <h1 className="welcome-title">Welcome to Life Fitness Partner</h1>
        <p className="welcome-subtext">New Member Registration Portal</p>

        <div className="button-container">
          <button className="big-btn" onClick={() => navigate("/assis/RegistrationHome")}>
            📝 Register New Member
          </button>

          <button className="big-btn blue" onClick={() => navigate("/members-lists")}>
            👥 View Pending Registrations
          </button>

          <button className="big-btn blue" onClick={() => navigate("/first-payments")}>
                      👥 Make First Payment
                    </button>
        </div>
      </div>
    </div>
  );
}
